
(function(template){
    define('vue!basicComponents/packageIndicatorPill',['Vue'],function(Vue){
        return {
            template:template,
            props: ['package_item','white_pill']
        }
    })
})('<span v-show="package_item" :class="[{\'white-bg\':white_pill},\'packageIndicator\']">{{localStrings.stepper.body.pick.service.pacakgeIndicator}} </span>');
